
import React, { useState, useEffect } from "react";
import backicon from "../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
// import DynamicForm from "../../../../../../customformComponent/customForm/DynamicForm";
// import axiosInstance from "../../../../../../services/api/API";
// import { showCustomAlert } from "../../../../../../customComponents/CustomSweetAlert";
// import { showErrorAlert } from "../../../../../../customComponents/CustomSweetAlert/errorsweetalert";
// import Loader from "../../../../../../customComponents/CustomLoader";
import DynamicForm from "../../../../DynamicForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";


    const EditItemCategory = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const [validationErrors, setValidationErrors] = useState({});
  const location = useLocation();
  const { data } = location.state || {};
  const [loading, setLoading] = useState(false);
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")
  const authToken = localStorage.getItem("authToken");
  const [ userTypedd, setUserTypedd ] = useState([])
  const [productOptions, setProductOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [warrantyOptions, setWarrantyOptions] = useState([]);
  const [hsncodeOptions, setHsncodeOptions] = useState([]);
  const [taxsetDropdown, setTaxSet] = useState([]);

  console.log(data, "getDataApi")




  useEffect(()=>{
    fetchItemDD()
    fetchUnitDD()
    fetchWarrrantyDD()  
    fetchHsncodeDD()
    fetchTaxSetDropdown()
      },[formData?.business_partner_id])
    
      const fetchWarrrantyDD = async () => {
        try {
    
          const payload = {
            orderBy: 'warranty_id desc',
            page: 0,
            pageSize: 100,
          }
    
          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }
    
          const response = await axiosInstance.post('/warranty/ddlwarranty', payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            }
          });
    
          const options = response.data.data.data.map(product => ({
            label: product.NAME,
            value: product.ID,
          }));
    
          setWarrantyOptions(options);
        } catch (error) {
          console.error('Error fetching product options:', error);
        }
      };
      const fetchUnitDD = async () => {
        try {
    
          const payload = {
            orderBy: 'unit_id desc',
            page: 0,
            pageSize: 100,
          }
    
          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }
    
          const response = await axiosInstance.post('/unit/ddlunit', payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            }
          });
    
          const options = response.data.data.data.map(product => ({
            label: product.NAME,
            value: product.ID,
          }));
    
          setUnitOptions(options);
        } catch (error) {
          console.error('Error fetching product options:', error);
        }
      };
    
      const fetchItemDD = async () => {
        try {
    
          const payload = {
            orderBy: 'item_id desc',
            page: 0,
            pageSize: 100,
          }
    
          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }
    
          const response = await axiosInstance.post('/itemtype/list', payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            }
          });
    
          const options = response.data.data.data.map(product => ({
            label: product.itemtype,
            value: product.itemtype_desc,
          }));
    
          setProductOptions(options);
        } catch (error) {
          console.error('Error fetching product options:', error);
        }
      };  
  

      const fetchTaxSetDropdown = async () => {
        try {
          const response = await axiosInstance.post(
            "/tax/ddltax",
            {},
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
    
          const formattedData = response?.data?.data?.data;
          console.log(formattedData, "VARIANTDATA");
    
          const variantData = formattedData.map((data) => ({
            value: data.ID,
            label: data.NAME,
            tax_percent: data?.tax_percent,
          }));
    
          setTaxSet(variantData);
        } catch (error) {
          console.error("Error fetching department list:", error);
        }
      };
    
  const fetchProductItemEdit = async () => {
    try {
        const response = await axiosInstance.get(`/partcategory/edit/${data.part_category_id}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
            },
        });

        const fetchedData = response.data.data;
        console.log("fetchedData",fetchedData);
        const transformedData = {
            itemtype: fetchedData.itemtype,
            part_category_name:  fetchedData.part_category_name ,
            part_category_desc: fetchedData.part_category_desc,
            // part_category_id:fetchedData.part_category_id,
        //   purchasePrice: fetchedData.purchase_price,
        //   sellingPrice: fetchedData.selling_price,
        //   warranty: fetchedData.warranty_id,
        //   hsnCode: fetchedData.hsnCode_id,
        //   unitQuantity:fetchedData.Unit_id,
        //   taxid:fetchedData?.tax_id,
          status: fetchedData.status==1?true:false

        };
        setFormData(transformedData); 
    } catch (error) {
        console.log(error);
    }
};

const handleFormSubmit = async (formData) => {
  console.log("itemdata", data);
  const errors = {};
  let isValid = true;

  console.log("formData", formData);

  // Form validation logic
  ItemInputs.forEach((field) => {
    if (field.validation) {
      if (field.name === "status" && formData.status === 0) {
        // Specific validation logic for status field if needed
      } else if (field.validation.required && !formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    }
  });

  if (!isValid) {
    setValidationErrors(errors);
    return;
  }
  // SweetAlert confirmation before API call
  showCustomAlert({
    title: "Confirmation",
    text: "Are you sure you want to update this item?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "Cancel",
    callback: async () => {
      try {
        setLoading(true)
        const payload = {
        //   item_name: formData.itemName,
        //   itemtype_id: formData.itemType,
        //   item_code: formData.itemCode,
        //   purchase_price: formData.purchasePrice,
        //   selling_price: formData.sellingPrice,
        //   warranty_id: formData.warranty,
        //   hsnCode_id: formData.hsnCode,
        //   Unit_id: formData.unitQuantity,
        //   tax_id:formData?.taxid,
        //   status: formData.status===true?1:0,

        itemtype: formData.itemtype,
        part_category_name:  formData.part_category_name ,
        part_category_desc: formData.part_category_desc,
        part_category_id:formData.part_category_id,
    //   purchasePrice: fetchedData.purchase_price,
    //   sellingPrice: fetchedData.selling_price,
    //   warranty: fetchedData.warranty_id,
    //   hsnCode: fetchedData.hsnCode_id,
    //   unitQuantity:fetchedData.Unit_id,
    //   taxid:fetchedData?.tax_id,
    status: formData.status===true?1:0,
        };

    

        const response = await axiosInstance.patch(`/partcategory/update/${data.part_category_id}`, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        console.log("API Response:", response.data);

        // Success alert after update
        showCustomAlert({
          title: "Success",
          text: "Item updated successfully.",
          icon: "success",
          confirmButtonText: "OK",
          callback: () => {
            navigate('/admin/manage-product/item-category'); // Navigate after user clicks OK
          },
        });
      } catch (error) {
        console.error('Error submitting form:', error);

        // Error alert
        const errorMessage = error.response?.data?.message;
        showErrorAlert({
          title: "Something went wrong",
          text:
            errorMessage ||
            "An error occurred while processing your request.",
          callback: () => {
            // Optional: code to execute after confirming the alert
            console.log("Error alert confirmed");
          },
        });
      }
      finally{
        setLoading(false)
      }
    },
  });
};

  useEffect(()=>{
    fetchProductItemEdit();
  },[])
  const fetchHsncodeDD = async () => {
    try {

      const payload = {
        orderBy: 'hsncode_id desc',
        page: 0,
        pageSize: 100,
      }

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post('/hsncode/ddlhsncode', payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      });

      const options = response.data.data.data.map(product => ({
        label: product.NAME,
        value: product.ID,
      }));

      setHsncodeOptions(options);
    } catch (error) {
      console.error('Error hsncode options:', error);
    }
  };

  const ItemInputs = [
    {
      name: "itemType",
      label: "Item Type",
      type: "dropdown",
      options: productOptions,
      required: true,
      validation: {
        required: true,
      },
      gridClass: "col-lg-4",
    },
    {
        name: "part_category_name",
        label: "Item Category Name",
        placeholder: "Enter Item Name",
        type: "text",
        required: true,
        validation: {
          required: true,
          pattern: /^[A-Za-z0-9-\s]*$/,
          message: "Special symbols are not allowed",
        },
        gridClass: "col-lg-4",
      },
      {
        name: "part_category_desc",
        label: "Item Category Description",
        placeholder: "Enter Item Name",
        type: "text",
        required: true,
        validation: {
          required: true
        },
        gridClass: "col-lg-4",
      },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      
      gridClass: "col-lg-4",
    },
  ];


  return (
    <>
       <div>
    {loading ? (
      <Loader />
    ) : (
      <><div className="backbutton mt-2 mb-2" onClick={() => navigate('/admin/manage-product/item-category')}>
              <img src={backicon} alt="back" />
              <span className="backbtntitle">Edit Item Category</span>
            </div><div className="form-container">
                <span className="cust-det-title mt-2 mb-2">
                  Please Enter Item Category Details
                </span>
                <DynamicForm
                  formConfig={ItemInputs}
                  formData={formData}
                  setFormData={setFormData}
                  onSubmit={handleFormSubmit}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors} />
              </div><div className="btncontainer mt-3">
                <button
                  onClick={() => handleFormSubmit(formData)}
                  className="submit-btn"
                >
                  Submit
                </button>
              </div></>)}
      </div>
    </>
  );
};

export default EditItemCategory;
